import React from 'react';

export default class Map extends React.Component {
  constructor(props) {
    super(props);
    var isMobile = {
      Android: function() {
          return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: function() {
          return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: function() {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: function() {
          return navigator.userAgent.match(/Opera Mini/i);
      },
      Windows: function() {
          return navigator.userAgent.match(/IEMobile/i);
      },
      any: function() {
          return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
      }
  };
    this.state = {
      map: null,
      zoom: 4,
      location: {lat:-36.7145372 , lng: -73.122315},
      overlays: [],
      markers: [],
      draggable: !isMobile.any()
    }
  }
  addCircle(map, location, y) {
    console.log(this.state);
    map.panTo(location);
    let marker = new google.maps.Marker({
        position: location,
        //draggable: true,
        map: map,
        title: ""
    });
    this.state.markers.push(marker);
    var vX = 0,
        vY = 0;
    var opt = {
        geodesic: true
    };
    var zX = new Array,
        zY = new Array;
    var circles = new Array;
    var polys = new Array;
    var aE1 = new google.maps.MVCArray;
    var aE2 = new google.maps.MVCArray;
    var aE3 = new google.maps.MVCArray;
    var aE4 = new google.maps.MVCArray;
    var grz = {};

    function pa(e, t) {
        var n = 1,
            r = 1;
        if (t == 1) {
            n = .38;
            r = 1.2;
            grz.c1 = "#ff9933"
        }
        if (t == 2) {
            n = .4;
            r = .88;
            grz.c2 = "#cc6666"
        }
        if (t == 3) {
            n = .34;
            r = .67;
            grz.c3 = "#660066"
        }
        if (t == 4) {
            n = .3;
            r = .55;
            grz.c4 = "#333333"
        }
        return Math.pow(e, n) * r
    }
    var circles = new Array();
    var polys = new Array();
    for (var i = 1; i < 5; i++) {
        circles[i] = new google.maps.Circle({
            center: location,
            clickable: false,
            map: map,
            radius: pa(y, i) * 700,
            strokeColor: eval("grz.c" + i),
            strokeOpacity: .2,
            strokeWeight: 1,
            fillColor: eval("grz.c" + i),
            fillOpacity: .4
        });
        this.state.overlays.push(circles[i])
    }
  }
  deleteMarkers() {
    if(this.state.markers){
      for(var e in this.state.markers){

        //if(grz.marker)grz.marker.setMap(null);
        this.state.markers[e].setMap(null)
      }
    }
  }
  deleteOverlays(){
    if(this.state.overlays){
      for(var e in this.state.overlays){
        this.state.overlays[e].setMap(null)
      }
    }
  }
  componentDidMount() {
    let map = new google.maps.Map(this.refs.map, {
      zoom: this.state.zoom,
      zoomControl: true,
      panControl: false,
      streetViewControl: false,
      zoomControlOptions: {
          style: google.maps.ZoomControlStyle.SMALL
      },
      center: new google.maps.LatLng(this.state.location.lat, this.state.location.lng),
      scaleControl: true,
      scaleControlOptions: {
          position: google.maps.ControlPosition.BOTTOM_CENTER
      },
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      draggable: this.state.draggable
    });
    this.setState({
      map: map
    });
  }
  render() {
    if(this.state.map != null) {
      this.deleteOverlays();
      this.deleteMarkers();
      this.props.items.map((item) => {
        if(this.props.active == item.year || this.props.active == 'all') {
          this.addCircle(this.state.map, new google.maps.LatLng(item.geo.lat, item.geo.lon) , Math.pow(item.magnitud , 7.4));
        }
        if(this.props.active != 'all') {
          this.state.map.setZoom(5);
        }
      });
    }
    return (
      <div ref="map" className="map columns small-12 medium-5">

      </div>
    )
  }
};



/** WEBPACK FOOTER **
 ** ./client/Map.js
 **/